// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MainPage_Wrapper__3H0Ec"};